import ChatInput from "./ChatInput";
import MessageList from "./MessageList";
import { chatRole } from "../../utils/data";
import { useDispatch, useSelector } from "react-redux";
import { setActiveChat } from "../../redux/features/chat/chatSlice";

const ChatWindow = ({ userId, role }) => {
  const dispatch = useDispatch();
  const { activeChat } = useSelector((s) => s.chat.chat);

  if (!activeChat) {
    return (
      <div class="ct_empty_chat_box_content">
        <div className="">
          <svg
            width="123"
            height="123"
            viewBox="0 0 123 123"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="0.956267"
              y="1.3696"
              width="120.87"
              height="120.87"
              rx="60.4348"
              fill="#F4F5FA"
            />
            <rect
              x="0.956267"
              y="1.3696"
              width="120.87"
              height="120.87"
              rx="60.4348"
              stroke="#E1E2E9"
              stroke-width="0.869565"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M76.764 77.1737C70.1202 83.8182 60.2823 85.2538 52.2315 81.5305C51.043 81.052 50.0686 80.6653 49.1423 80.6653C46.5621 80.6806 43.3505 83.1824 41.6814 81.5152C40.0122 79.8459 42.516 76.6318 42.516 74.036C42.516 73.1096 42.1446 72.1526 41.6661 70.9618C37.9411 62.9123 39.3787 53.0711 46.0225 46.4288C54.5036 37.9445 68.2828 37.9445 76.764 46.4266C85.2605 54.924 85.2452 68.6916 76.764 77.1737Z"
              fill="#BEC0CA"
              stroke="#8B8D97"
              stroke-width="1.30435"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M69.9541 62.7022H69.9737"
              stroke="#8B8D97"
              stroke-width="1.73913"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M61.2412 62.7022H61.2608"
              stroke="#8B8D97"
              stroke-width="1.73913"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M52.5244 62.7022H52.544"
              stroke="#8B8D97"
              stroke-width="1.73913"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <div>
            <h4 class="ct_fs_20 ct_fw_600">Messages</h4>
            <p>Click on a contact to view messages.</p>
            
          </div>
        </div>
      </div>
    );
  }

  return (
    <div class={`chatbox ${!activeChat ? "" : "showbox"}`}>
      <div class="ct_white_bg ct_border_radius_10 ct_p_20 h-100">
        <div class="ct_modal-dialog-scrollable">
          <div class="modal-content ct_chatroom_modal_content">
            <div class="d-block">
              <div class="msg-head d-flex align-items-center justify-content-between gap-3 flex-wrap">
                <div class="d-flex align-items-center gap-2 ">
                  <i
                    class="fa-solid fa-chevron-left chat-icon"
                    onClick={() => {
                      dispatch(setActiveChat(null));
                    }}
                  ></i>
                  <div class="ct_grid_50_auto">
                    <img
                      src={
                        activeChat?.opposite_user?.profile_image ||
                        "../assets/img/user_profile.png"
                      }
                      alt=""
                    />
                    <div>
                      <h4 class="ct_fs_18 ct_fw_600  mb-0">
                        {activeChat?.opposite_user?.full_name || "#N/A"}

                        <span className="ct_fs_12 ct_fw_400">
                          ( {chatRole[activeChat?.opposite_user?.type] || "#N/A"}){" "}
                        </span>
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
              <MessageList userId={userId} />
              <ChatInput userId={userId} role={role} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatWindow;
